import "App.scss"
import { useContext, useState, useCallback, useEffect } from "react"
import { CartContext } from "App"
import { FlexRowContainer } from "components/AllHelpComponents"

import { useTranslation } from "react-i18next"
import i18n from "helpers/i18n"

import { Box, Typography } from "@mui/material"

import default_dish_img from "images/svg_dishes/pot-dinner-svgrepo-com.svg"
import toppings_icon from "images/toppings_icon.png"
import isPhotoUrl from "helpers/isPhotoUrl"

export function CardRowSmall({ food }) {
  // console.log("food222", food);
  const {
    title,
    image,
    price,
    quantity,
    textColor,
    toppings,
    selectedToppings,
    selectedExtrasNames,
    translations,
    selectedChoices,
    selectedAddons,
  } = food
  const priceAllItems = (price * (quantity || 1)).toFixed(2)
  const { t } = useTranslation()
  const { language, settings } = useContext(CartContext)

  const calculateTotalPrice = () => {
    let totalPrice = parseFloat(priceAllItems) // Инициализируем сумму исходной ценой товара

    // Добавляем стоимость выбранных топпингов, если они есть
    if (selectedToppings && selectedToppings.length > 0) {
      selectedToppings.forEach((selectedTopping) => {
        const topping = toppings.find((t) => t.title?.trim() === selectedTopping.trim())
        if (topping) {
          totalPrice += topping.price * (quantity || 1)
        }
      })
    }

    if (selectedChoices?.length) {
      selectedChoices.forEach((choice) => {
        choice.options.forEach((option) => {
          totalPrice += option.price || 0
        })
      })
    }

    if (selectedAddons?.length) {
      selectedAddons.forEach((addon) => {
        addon.options.forEach((option) => {
          totalPrice += option.price || 0
        })
      })
    }

    return totalPrice.toFixed(2) // Возвращаем общую цену с округлением до двух знаков после запятой
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1.5,
          mb: 1,
          borderRadius: "6px",
          backgroundColor: "#131415",
          transition: "background-color 0.2s",
          "&:hover": {
            backgroundColor: "#1a222c",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1 }}>
          <Box
            sx={{
              width: "60px",
              height: "60px",
              borderRadius: "6px",
              overflow: "hidden",
              flexShrink: 0,
              border: "1px solid #2e30adff"
            }}
          >
            <img
              src={isPhotoUrl(image) ? image : default_dish_img}
              alt={title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
            />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: "0.95rem",
                fontWeight: 600,
                color: "#f4f5f5",
                mb: 0.5,
                lineHeight: 1.3
              }}
            >
              {translations && translations[language] ? translations[language] : title}
            </Typography>

            {selectedExtrasNames && Object.keys(selectedExtrasNames).length > 0 && (
              <Box sx={{ mt: 0.5 }}>
                {Object.keys(selectedExtrasNames).map((key) => (
                  <Typography
                    key={key}
                    sx={{
                      fontSize: "0.75rem",
                      color: "#b1bfcf",
                      lineHeight: 1.4
                    }}
                  >
                    {key}: {selectedExtrasNames[key]}
                  </Typography>
                ))}
              </Box>
            )}

            {quantity && quantity !== 1 && (
              <Typography sx={{ fontSize: "0.8rem", color: "#b1bfcf", mt: 0.5 }}>
                {price} x {quantity}
              </Typography>
            )}
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: "bold",
            color: "#5cb8ffff",
            ml: 2,
            flexShrink: 0
          }}
        >
          {price ? priceAllItems : "0.00"}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
        </Typography>
      </Box>

      {selectedChoices?.length > 0 &&
        selectedChoices.map((choice) => (
          <Box
            key={choice.id}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1,
              px: 2,
              mx: 1,
              mb: 0.5,
              borderRadius: "4px",
              backgroundColor: "#131415",
              borderLeft: "2px solid #5cb8ffff"
            }}
          >
            <Typography sx={{ fontSize: "0.85rem", color: "#b1bfcf" }}>
              {choice.name_translations?.[language] || choice.name}:{" "}
              {choice.options[0].name_translations?.[language] || choice.options[0].name}
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#5cb8ffff" }}>
              {choice.options[0].price.toFixed(2)}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
            </Typography>
          </Box>
        ))}

      {selectedAddons?.length > 0 &&
        selectedAddons.map((addon) => {
          return addon.options.map((option) => (
            <Box
              key={option.id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py: 1,
                px: 2,
                mx: 1,
                mb: 0.5,
                borderRadius: "4px",
                backgroundColor: "#131415",
                borderLeft: "2px solid #5cb8ffff"
              }}
            >
              <Typography sx={{ fontSize: "0.85rem", color: "#b1bfcf" }}>
                {addon.name_translations?.[language] || addon.name}:{" "}
                {option.name_translations?.[language] || option.name}
              </Typography>
              <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#5cb8ffff" }}>
                {option.price.toFixed(2)}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
              </Typography>
            </Box>
          ))
        })}

      {/* selectedToppings */}
      {selectedToppings?.length > 0 &&
        selectedToppings.map((selectedTopping, index) => {
          const topping = toppings.find((t) => t.title?.trim() === selectedTopping.trim())

          if (!topping) return null

          return (
            <Box
              key={topping.title + index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py: 1,
                px: 2,
                mx: 1,
                mb: 0.5,
                borderRadius: "4px",
                backgroundColor: "#131415",
                borderLeft: "2px solid #5cb8ffff"
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "4px",
                    overflow: "hidden",
                    border: "1px solid #2e30adff"
                  }}
                >
                  <img
                    src={isPhotoUrl(topping.image) ? topping.image : toppings_icon}
                    alt={topping.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </Box>
                <Typography sx={{ fontSize: "0.85rem", color: "#b1bfcf" }}>
                  {t(topping.title)}
                  {quantity !== 1 && (
                    <span style={{ marginLeft: "5px", fontSize: "0.75rem" }}>
                      ({topping.price} x {quantity})
                    </span>
                  )}
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#5cb8ffff" }}>
                {(topping.price * (quantity || 1)).toFixed(2)}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
              </Typography>
            </Box>
          )
        })}

      {title !== "Total Price:" && (
        <Box>
          {console.log("Number(calculateTotalPrice() >> ", Number(calculateTotalPrice()))}
          {console.log("price >> ", price)}
          {price !== Number(calculateTotalPrice()) && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py: 1.5,
                px: 2,
                mx: 1,
                mt: 1,
                mb: 0.5,
                borderRadius: "6px",
                backgroundColor: "#1a222c",
                border: "1px solid #2e30adff"
              }}
            >
              <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, color: "#f4f5f5" }}>
                {t("Total Dish Price:")}
              </Typography>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", color: "#5cb8ffff" }}>
                {calculateTotalPrice()}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
              </Typography>
            </Box>
          )}

          <Box sx={{ width: "100%", height: "1px", backgroundColor: "#b1bfcf", opacity: 0.2, my: 1.5 }}></Box>
        </Box>
      )}
    </>
  )
}
